module.exports = __webpack_public_path__ + "static/media/olas.footer.51fab6e0.png";